import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || 'Unknown render error' };
  }

  componentDidCatch(error, info) {
    console.error('PageErrorBoundary caught error:', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, errorMessage: '' });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          This page crashed while rendering.
        </Alert>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          {this.state.errorMessage}
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button variant="contained" onClick={this.handleRetry}>Retry</Button>
          <Button variant="outlined" onClick={() => window.location.reload()}>Hard reload</Button>
        </Stack>
      </Box>
    );
  }
}

export default PageErrorBoundary;
